import { environment } from '../../environments/environment';

export const AppConfig = {
    apiUrl: environment.apiUrl,
    propertyUrl:"https://rapidrecon-dev-us-east-api-external.azurewebsites.net/api/PropertyData/BasIcInfo",
    apiKey: "a53b4be0-1844-44bd-b775-c48854547783",
    pageTitle:environment.pageTitle,
    storageSecret: environment.storageSecret
};